var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-rule-view"},[_c('h5',{staticClass:"title"}),_vm._v(" "),_c('div',{staticClass:"rule-text"},_vm._l((_vm.rule_text),function(item,index){return _c('div',{key:index},[_c('em',{staticClass:"tag",domProps:{"innerHTML":_vm._s(index+1)}}),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(item.text)}})])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-939f7a1e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/evtrule.vue
// module id = null
// module chunks = 